export default "__VITE_ASSET__9GADVc2O__"